module.exports = __webpack_public_path__ + "img/9788959402052.b5615b69.jpg";